// Query keys das notificações de risco. Em módulo próprio (não no index que declara hooks) pra as mutations
// importarem sem barrel/import circular.
export const RISK_RECOGNITION_HIGHLIGHT_QUERY_KEY = 'RISK_RECOGNITIONS_HIGHLIGHTS';
export const RISK_RECOGNITION_LIST_QUERY_KEY = 'RISK_RECOGNITIONS_LIST';
